export default {"src":"/_next/static/media/newIn.c55fb177.gif","height":36,"width":36,"blurWidth":0,"blurHeight":0};